import { render } from "./TakeRatesUpdateTable.vue?vue&type=template&id=37d47077"
import script from "./TakeRatesUpdateTable.vue?vue&type=script&lang=js"
export * from "./TakeRatesUpdateTable.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./TakeRatesUpdateTable.vue?vue&type=style&index=0&id=37d47077&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script